import {ITokenStorageService} from '../token-storage.service';

export const tokenSenderInterceptorFactory =
    (tokenStorageService:ITokenStorageService, backendUrl:string) => {
      return {
        request: (config:ng.IRequestConfig):ng.IRequestConfig => {
          if (config.url.indexOf(backendUrl) == 0) {
            config.headers = config.headers || {};
            const storedToken = tokenStorageService.getToken();
            if (storedToken != null) {
              config.headers['Authorization'] = `Bearer ${storedToken.tokenString}`;
            }
          }
          return config;
        }
      };
    };

tokenSenderInterceptorFactory.$inject = ['tokenStorageService', 'backendUrl'];



/** WEBPACK FOOTER **
 ** ./app/auth/interceptor/token-sender.ts
 **/